<template>
    <div class="form-item">
        <label class="label-caption">Situação Agenda</label>
        <select :value="opcaoSelecionada" @change="atualizarOpcao" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>

  
<script setup>
import { computed } from 'vue'


const props = defineProps({
    ckAddTodos: {type: Boolean, default: false},
    opcaoSelecionada: {type: Number, default: null}
})


const emit = defineEmits(['update:opcaoSelecionada'])


const lsTipos = computed(() => {
    const tipos = [
        { id: 1, descricao: 'AGUARDANDO' },
        { id: 5, descricao: 'ATENDIDA' },
        { id: 9, descricao: 'CANCELADA' }
    ];
    if (props.ckAddTodos) {
        tipos.unshift({ id: 0, descricao: 'TODOS' })
    }
    return tipos
})


function atualizarOpcao(event) {
    emit('update:opcaoSelecionada', Number(event.target.value))
}
</script>